import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const badgeVariants = {
  success: 'badge badge-success',
  warning: 'badge badge-warning',
  danger: 'badge badge-danger',
  info: 'badge badge-info',
  neutral: 'badge badge-neutral',
} as const;

export type BadgeVariant = keyof typeof badgeVariants;

export function badgeClassName(variant: BadgeVariant = 'neutral', className?: string) {
  return cn(badgeVariants[variant], className);
}

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'neutral', ...props }, ref) => (
    <span ref={ref} className={badgeClassName(variant, className)} {...props} />
  ),
);
Badge.displayName = 'Badge';
